// extracted by mini-css-extract-plugin
export default {"lists":"PopUpMobile_lists__YM7HA"};